import { Divider, Stack, styled } from "@mui/material"
import type { ApiSales, SafeApiComponentProps } from "@pharmupp/p3-front-commons"
import { PriceKPIDisplayEvolution } from "../../../common"

export const SalesSummarySection = ({ salesValue, salesMargin }: ApiSales) => {
  return (
    <SalesSummaryContainer>
      <PriceKPIDisplayEvolution
        label="CHIFFRE AFFAIRES à J-7"
        keyFigure={salesValue}
      />
      <PriceKPIDisplayEvolution label="MARGE" keyFigure={salesMargin} />
    </SalesSummaryContainer>
  )
}

SalesSummarySection.suspense = {
  skeletonProps: { height: 140 },
} satisfies SafeApiComponentProps["suspense"]

const SalesSummaryContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(10),
  padding: theme.spacing(0, 1),
}))
SalesSummaryContainer.defaultProps = {
  divider: <Divider orientation="vertical" flexItem />,
}
